var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('asc-fault-monitor-item-header',{attrs:{"item":_vm.item}}),_vm._l((_vm.item.values),function(detailItem,index){return _c('asc-fault-monitor-detail-item',{key:index,attrs:{"item":detailItem}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }